import { render, staticRenderFns } from "./PerformanceComparison.vue?vue&type=template&id=2a473ade&scoped=true&"
import script from "./PerformanceComparison.vue?vue&type=script&lang=ts&"
export * from "./PerformanceComparison.vue?vue&type=script&lang=ts&"
import style0 from "./PerformanceComparison.vue?vue&type=style&index=0&id=2a473ade&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a473ade",
  null
  
)

export default component.exports